import React, { FC, useEffect, useState } from 'react'
import Modal from './Modal'

interface Member {
  id: number
  name: string
  kana: string | null
  email: string
  code: string | null
  team_name: string,
  profile_image: string | null
  use_common_setting: boolean
  value: string | null
}

interface Props {
  targetMemberList: Member[]
  selectList: {
    label: string,
    value: string,
  }[]
  label: string
  prefix?: string
  isDisplayModal: boolean
  submitCallback: (data: {commonFlg: boolean, memberIds: number[], type: string}) => void
  closeCallback: VoidFunction
  winOnly?: boolean
}

const DISPLAY_MODAL_MEMBER_LIMIT = 30

const SettingModal: FC<Props> = (props) => {
  const {
    targetMemberList,
    selectList,
    label,
    prefix,
    isDisplayModal,
    submitCallback,
    closeCallback,
    winOnly,
  } = props

  const [selectType, setSelectType] = useState<string>("common")

  const close = () => {
    closeCallback()
  }

  const submit = (data: {commonFlg: boolean, memberIds: number[], type: string}) => {
    submitCallback(data)
  }

  useEffect(() => {
    if (targetMemberList.length === 1 && targetMemberList[0]?.value) {
      const tmp = selectList.find((v) => v.value === targetMemberList[0].value)?.value
      setSelectType(tmp || "common")
    }
  }, [targetMemberList])

  useEffect(() => {
    if (isDisplayModal) return
    setSelectType("common")
  }, [isDisplayModal])

  return (
    <Modal
      show={isDisplayModal}
      wrapperClass="w900"
      closeCallback={close}
      closeable
    >
      <>
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            marginBottom: "16px",
          }}
        >
          {label}
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              border: "solid 1px #999999",
              borderRadius: "4px",
              padding: "8px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
              backgroundColor: "#F3F3f3",
            }}
          >
            <div>
              対象
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
              }}
            >
              {
                targetMemberList.slice(0, DISPLAY_MODAL_MEMBER_LIMIT).map((v) => (
                  <div
                    key={`member_${v.id}`}
                    style={{
                      border: "solid 1px #999999",
                      borderRadius: "20px",
                      padding: "2px 8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "10px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <img
                      alt={v.name}
                      src={v.profile_image ?? `/static/images/profile/${(Number(v.id) || 0) % 12}.jpeg`}
                      style={{ width: "16px", height: "16px", borderRadius: "50%" }}
                    />
                    {v.name}
                  </div>
                ))
              }
              {
                targetMemberList.length > DISPLAY_MODAL_MEMBER_LIMIT && (
                  <div
                    style={{
                      padding: "3px",
                    }}
                  >
                    {`…他${targetMemberList.length - DISPLAY_MODAL_MEMBER_LIMIT}名`}
                  </div>
                )
              }
            </div>
          </div>
          <div
            style={{
              border: "solid 1px #999999",
              borderRadius: "4px",
              padding: "8px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
            }}
          >
            <div>
              {label}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {`${prefix || `${label}を`}…`}
              <select
                style={{
                  border: "solid 1px #999999",
                  padding: "4px",
                  borderRadius: "4px",
                  appearance: "auto",
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                }}
                onChange={(e) => setSelectType(e.target.value)}
                value={selectType}
              >
                {
                  selectList.map((v) => (
                    <option key={`select_type_${v.value}`} value={v.value}>
                      {v.label}
                    </option>
                  ))
                }
              </select>
            </div>
          </div>
          {
            winOnly && (
              <div
                style={{
                  border: "solid 1px #FF0000",
                  borderRadius: "4px",
                  padding: "8px",
                  color: "#FF0000",
                  backgroundColor: "#ffeeee",
                }}
              >
                ※ Windows版限定の機能になります。設定の際はご注意ください。
              </div>
            )
          }
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginTop: "32px",
            }}
          >
            <button
              type="button"
              style={{
                border: `solid 1px #999999`,
                borderRadius: "4px",
                backgroundColor: "#EEEEEE",
                color: "#666666",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={close}
            >
              キャンセル
            </button>
            <button
              type="button"
              style={{
                border: `solid 1px #507DC0`,
                borderRadius: "4px",
                backgroundColor: "#507DC0",
                color: "#FFFFFF",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={() => submit({
                commonFlg: false,
                memberIds: targetMemberList.map((v) => v.id),
                type: selectType,
              })}
            >
              設定する
            </button>
          </div>
        </div>
      </>
    </Modal>
  )
}

SettingModal.defaultProps = {
  prefix: "",
  winOnly: false,
}

export default SettingModal
